import React, { PropTypes } from 'react';
import classNames from 'classnames';
import InputGroup from '../InputGroup';
import BaseField from './Base';


export default class Input extends BaseField {
  static propTypes = {
    placeholder: PropTypes.string,
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    group: PropTypes.shape({})
  };

  static defaultProps = {
    type: 'text',
  };

  render() {
    const { id } = this.state;
    const {
      group,
      type,
      label,
      placeholder,
      input,
      meta: { error, touched, invalid }
    } = this.props;

    return (
      <InputGroup id={id} invalid={touched && invalid} label={label} {...group}>
        <input
          type={type}
          {...input}
          id={id}
          placeholder={placeholder}
          className={classNames("form-control", {"form-control-danger": invalid})}
        />
        { (touched && error) && <div className="form-control-feedback">{error}</div> }
      </InputGroup>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/Field/Input.js